module.exports = __webpack_public_path__ + "static/media/image404.748bdd98.svg";